export default __webpack_public_path__ + "static/media/brain_x.e0ca3e75.png";